import { connect } from "react-redux";

var Features = require("lib/account/Features");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");
var StudentDisplay = require("components/users/students/StudentDisplay");


var ReactTooltip = require("react-tooltip");

var RosterSelectors = require("lib/selectors/RosterSelectors");


require("writing/answers/answer_display.scss");

@connect(
  (state, props) => {
    var answer = WritingSelectors.answer({ state, id: props.answerID });
    var passProps = {
      answer: answer,
    };

    if (answer) {
      passProps.question = WritingSelectors.question({ state, id: answer.question_id });
      var student = RosterSelectors.student({ state, id: answer.user_id });

      passProps.quizEvaluation = WritingSelectors.evaluationForSubject({
        state,
        subjectType: "Quiz",
        subjectID: answer.quiz_id,
      });

      passProps.answerEvaluation = WritingSelectors.evaluationForSubject({
        state,
        subjectType: "Answer",
        subjectID: answer.id,
      });

      if (answer.evaluation) {
        var evaluation = WritingSelectors.evaluation({ state, id: answer.evaluation });
        if (evaluation) {
          passProps.evaluation = evaluation;
        }
      }
    }

    if (student) {
      passProps.studentReadingLevel = student.current_reading_level;
    }

    passProps.blockComments = !Features.isEnabled(Features.TEACHER_COMMENTS);
    return passProps;
  },
  (dispatch, props) => ({})
)
class AnswerReview extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      controlMode: null,
    };
  }

  render() {
    var { answer } = this.props;

    var className = "answerDisplay writingDisplay clearfix nonFITB";

    var questionDisplay = <p className="questionText">{answer.question_text}</p>;
  
    var answerBody = (
      <div className="answerText">
        <MultiPartAnswerDisplay parts={answer.parts} breakSections />
      </div>
    );
 
    return (
      <div className={className}>
        <div className="innerWrap">
          <div className="innerAnswer">
            {questionDisplay}
            {answerBody}
          </div>
        </div>
      </div>
    );
  }
}

AnswerReview.defaultProps = {
  enabled: {},
};

AnswerReview.WrappedComponent.propTypes = StrictPropTypes({
  // ID of the answer to be displayed
  answerID: PropTypes.number.isRequired,

  // From @connect
  // Which are present is determined by the other props
  answer: PropTypes.object.isRequired,
  question: PropTypes.object,
  enabled: PropTypes.object,
  quizEvaluation: PropTypes.object,
  answerEvaluation: PropTypes.object,
  evaluation: PropTypes.object,
  studentReadingLevel: PropTypes.number,
  blockComments: PropTypes.bool,
});

module.exports = AnswerReview;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerReview.js